import { gql } from '@apollo/client';

const CURRENT_USER = gql`
  query CurrentUser {
    currentUser {
      uuid
      email
      examCredits
      nickname
      promo
      referralCode
      activeProductSlug
      organizationUuid
      termsAt
      grants {
        scope
        targetType
        targetUuid
      }
      subscriptions {
        uuid
        productUuid
        status
        expiresAt
        product {
          uuid
          slug
        }
      }
    }
  }
`;

export default CURRENT_USER;
